<template>
    <div class="region_list">
        <ul class="tov_select">
            <li v-for="item in organizations" @click.prevent="set_active(item)"   :class="class_org(item)" >
                {{item.text}}
            </li>
        </ul>

        <user_list v-bind:users="userlist"></user_list>
    </div>
</template>

<script>
    import user_list from './users_list.vue'

    export default {
        name: "organization",

        components : {
            user_list,
        },


        created() {
            console.log('org_created');

            if (this.organizations.length == 0){
                this.load_organizations();
            }

            this.load_users();
        },


        data () {
            return {
                form : {
                    org_name : '',
                    cur_type : 'organization'
                },

            }
        },

        computed: {
            
            
            
            
            organizations () {
                return  this.$store.state.users_filter.organizations;
            },

            active_organization ()  {
                return  this.$store.state.users_filter.active_organization;
            },

            send_form () {
                this.form.org_name = this.active_organization.text;
                return qs.stringify(this.form);
            },

            userlist () {
                return  this.$store.state.users_filter.users;
            }

        },

        methods: {

            set_active (item) {
                this.$store.dispatch('SET_ACTIVE_ORG', item);
                this.load_users();
            },


            async load_organizations ()  {
                await axios.get('/index.php?option=com_imc_docs&task=users.getUserOrganizations').then(({data}) => {
                    if (data.status == "operation_success") {
                        console.log(data);
                        this.$store.dispatch('SET_ORG_LIST', data.message);
                    }
                }).catch(err => {
                    console.log(err);
                });
            },

            async load_users ()  {
                this.$store.dispatch('SET_USERS_LIST', []);

               if(this.obj_to_null(this.active_organization)) {


                    await axios.post('/index.php?option=com_imc_docs&task=users.getFilterUsers',this.send_form).then(({data}) => {
                        console.log(data);
                        if (data.status == "operation_success") {
                            this.$store.dispatch('SET_USERS_LIST', data.message);
                        }
                    }).catch(err => {
                        console.log(err);
                    });
                }
            },


            class_org(item) {
                if(item.value === this.active_organization.value) {
                    return 'active';
                }
                return  '';

            }
        },

    }
</script>

<style scoped>

</style>
